import React from 'react'
import { Controller } from 'react-hook-form'

import Checkbox from '@/components/Form/Checkbox'

export function AuthCheckboxField ({ control, name, label, ...props }) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <>
          <Checkbox
            {...props}
            name={name}
            label={label}
            value={Boolean(field.value)}
            onChange={(_, checked) => field.onChange(checked)}
          />
          {fieldState.error?.message && (
            <span style={{ color: '#e74c3c', fontSize: '0.85em', paddingLeft: '1em' }}>
              {fieldState.error.message}
            </span>
          )}
        </>
      )}
    />
  )
}

export default AuthCheckboxField
